









































import Vue from 'vue'
import Student from '@/models/Students/Student'
import {USER_ROLE_STUDREMOVE} from '@/constants'
export default Vue.extend({
  props: {
    scope: {} as () => {student: Student},
    options: {}
  },

  data () {
    return {
      actionsVissible: false
    }
  },

  methods: {
    async toggleActions () {
      this.actionsVissible = !this.actionsVissible;
    },

    async deleteUser () {
      this.$confirm(this.$t('labels.delete_user_warning').toString(), this.$t('labels.attention').toString(), {
        confirmButtonText: this.$t('labels.delete').toString(),
        cancelButtonText: this.$t('labels.cancel').toString(),
        type: 'warning'
      })
        .then(async () => {
          try {
            await this.$store.dispatch('students/deleteStudent', this.scope.student.getId())
            this.$message({
              message: this.$t('labels.student_deleted').toString(),
              type: 'success'
            });
            this.$router.push({name: 'studentsList'});
          } catch (error) {
            console.error(error)
          }
        })
    }
  },

  computed: {
    canDelete (): boolean {
      if (this.$store.state.user.user) {
        return this.$store.state.user.user.checkRole(USER_ROLE_STUDREMOVE)
      }

      return false
    }
  }
})
